export const STAT_BASE_URL = 'http://localhost:3000';
export const STAT_CONN_ID = 'a15ec674979ba7353afc3eb4e0708755';
